import { Container } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiAddressBook } from 'react-icons/pi';
import { useGetCountries } from 'services/enums';
import { useStateStorage } from 'store/state';

interface IAddressFormProps {
  propertyPrefix: string;
  title?: string;
  icon?: ReactNode;
  topContent?: ReactNode;
  bottomContent?: ReactNode;
  noHeader?: boolean;
  noMaxWidth?: boolean;
}

const AddressForm = ({
  icon = <PiAddressBook />,
  title,
  propertyPrefix = '',
  bottomContent,
  topContent,
  noHeader = false,
  noMaxWidth = false,
}: IAddressFormProps) => {
  const { t } = useTranslation();

  const { countries: storeCountries } = useStateStorage();
  const { data: fetchedCountries } = useGetCountries(!storeCountries?.length);
  const countries = storeCountries?.length ? storeCountries : (fetchedCountries ?? []);

  const countryOptions =
    countries?.map(country => ({
      label: t(`countries.${country.codeAlfa2}`),
      value: country.codeAlfa2,
    })) ?? [];

  const inputWrapperClassName = noMaxWidth ? 'max-w-full' : undefined;

  const containerClassName = noMaxWidth
    ? 'self-start w-full'
    : 'self-start w-full max-w-[350px]';

  return (
    <Container className={containerClassName}>
      {!noHeader && (
        <Container.Header
          title={
            <>
              {icon} {title ?? t('molecules.sections.address')}
            </>
          }
        />
      )}
      {topContent}
      <Container.Content>
        <div className='flex flex-col w-full gap-3'>
          <FormInput.Select
            name={`${propertyPrefix}countryAlfa2`}
            label={t('input.label.country')}
            options={countryOptions}
            wrapperClassName={inputWrapperClassName}
          />
          <FormInput.Text
            name={`${propertyPrefix}zipCode`}
            label={t('input.label.zipCode')}
            wrapperClassName={inputWrapperClassName}
          />
          <FormInput.Text
            name={`${propertyPrefix}city`}
            label={t('input.label.city')}
            wrapperClassName={inputWrapperClassName}
          />
          <FormInput.Text
            name={`${propertyPrefix}street`}
            label={t('input.label.street')}
            wrapperClassName={inputWrapperClassName}
          />
          <FormInput.Text
            name={`${propertyPrefix}houseNumber`}
            label={t('input.label.houseNumber')}
            wrapperClassName={inputWrapperClassName}
          />
          <FormInput.Text
            name={`${propertyPrefix}flatNumber`}
            label={t('input.label.flatNumber')}
            wrapperClassName={inputWrapperClassName}
          />
        </div>
      </Container.Content>
      {bottomContent}
    </Container>
  );
};

export default AddressForm;
